import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTableStack = styled(Stack)({
  height: "100%",
  overflow: "hidden",
  "@media print": {
    height: "fit-content",
    overflow: "visible",
    ".HubTableTemplate-stack": {
      height: "fit-content",
      overflow: "visible",
    },
  },
});
